<style lang="less" scoped>
.container-div {

}
.title-div {
  font-weight: 600;
  margin: 20px 10px 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
}
.history{
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #4182EB;
  line-height: 20px;
  height: 25px;
  margin-top: 40px;
  cursor: pointer;
}
.custInfo_container{
  width: 100%;
  margin: 20px 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;

  .cust-item{
    width: 25%;
  }
}
.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;
  >div:first-of-type{
    // width: 120px;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }
  >div:last-of-type{
    font-size: 14px;
    min-width: 160px;
    text-align: right;
  }

}

.cust-detail-title {
  // text-align: ;
  // margin-right: 50px;
  // width: 150px;
}
// .cust-detail-item {
//   // t-w
// }
.page-action-btns {
  margin-bottom: 10px;
}
.cust-mes {
  margin: 0px 0px 14px 18px;
}
.top-title-div {
  font-size: 15px;
  margin-left: 10px;
}
.red-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 100px;
}
.detail-btn {
  height: 32px;
  margin-left: 45px;
  margin-top: 10px;
}
</style>

<template>
  <div class="detail-content-div">
    <div class="flex" v-if="custInfo.custType!=='亲友账号'">
      <div class="title-div">亲友信息</div>
      <div class="history" @click="openHistorydig(true)">历史信息</div>
    </div>
    <el-table
        class="el-table"
        :data="detailForm.relList"
        border
        max-height="300px"
        style="width: 100%;margin:20px auto"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{background:'#FAFAFA',color:'#8F9BB3',fontSize: '14px',textAlign:'center', border: '1px solid #F0F0F0'}"
        >
          <el-table-column
              prop="mobile"
              label="用户手机号">
              <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.mobile" clearable></el-input>
              </template> -->
          </el-table-column>
          <el-table-column
              prop="custType"
              label="亲友类型">
          </el-table-column>
          <el-table-column
              prop="pileCode"
              label="共享充电桩">
          </el-table-column>
          <el-table-column
              prop="content"
              label="状态">
              <template><span>已添加</span></template>
          </el-table-column>
          <el-table-column
            prop="createdWhen"
            label="添加时间">
        </el-table-column>
    </el-table>
    <div class="flex" v-if="custInfo.custType!=='主账号'">
      <div class="title-div">桩主信息</div>
      <div class="history"  @click="openHistorydig(false)">历史信息</div>
    </div>
    <el-table
        v-if="custInfo.custType!=='主账号'"
        class="el-table"
        :data="detailForm.masterList"
        border
        max-height="200px"
        style="width: 100%;margin:20px auto"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{background:'#FAFAFA',color:'#8F9BB3',fontSize: '14px',textAlign:'center', border: '1px solid #F0F0F0'}"
        >
        <el-table-column
            prop="mobile"
            label="用户手机号">
        </el-table-column>
        <el-table-column
            prop="custType"
            label="亲友类型">
        </el-table-column>
        <el-table-column
            prop="pileCode"
            label="共享充电桩">
        </el-table-column>
        <el-table-column
            prop="content"
            label="状态">
        <template><span>已添加</span></template>
        </el-table-column>
        <el-table-column
            prop="createdWhen"
            label="添加时间">
        </el-table-column>
    </el-table>
    <el-dialog :visible.sync="historyDialogVisible" >
      <div class="phone">
      <el-table
        class="el-table"
        :data="detailForm.relHistoryList"
        border
        max-height="200px"
        style="width: 100%;margin:20px auto"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{background:'#FAFAFA',color:'#8F9BB3',fontSize: '14px',textAlign:'center', border: '1px solid #F0F0F0'}"
        >
          <el-table-column
              prop="mobile"
              width="160"
              label="用户手机号">
          </el-table-column>
          <el-table-column
              prop="custType"
              label="亲友类型">
          </el-table-column>
          <el-table-column
              prop="pileCode"
              width="180"
              label="共享充电桩">
          </el-table-column>
          <el-table-column
              prop="content"
              label="状态">
              <template><span>已移除</span></template>
          </el-table-column>
          <el-table-column
              prop="lastModifiedWhen"
              label="移除时间">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      chargeData: [],
      selections: [], // 表格选项
      pagination: pageConfig.detailPagination,
      editFlag: false,
      pageTitle: '客户详情',
      // 默认值设置
      detailForm: {
        relList:[],
        masterList:[],
        relHistoryList:[],
      },
      custInfo:{},
      custDto: {}, //未使用
      queryInfo: {}, // 默认内容
      dialogForm: {
        //度电设置弹窗内容
        remark: '',
        chargeValue: '',
      },
      activeName: 'first', //默认激活状态
      operates: {
        width: 220,
        fixed: 'right',
        list: [
          {
            id: 'remark',
            label: '备注',
            type: 'primary',
            show: true,
            disabled: false,
            method: (index, row) => {
              this.openRemark(row)
            },
          },
        ],
      }, // 列操作按钮

      caroperates:{
        width: 220,
        fixed: 'right',
        list: []
      },
      historyDialogVisible: false, //未使用(已删除功能)
      thirdDialogFormVisible: false, //度电设置弹窗
      dialogTitle: '', //未使用(已删除功能)
      dialogLabel: '', //未使用(已删除功能)
      actInExpAmount: '', //未使用(已删除功能)
      recentInTime: '暂无充值记录', //未使用(已删除功能)
      totalChargeValue: '', //累计度电
      chargeBalanceValue: '', //剩余度电
      tipFlag: false, //度电设置弹窗错误提示语
      btnUse: false, //判断是否可以点击确定按钮
      remarkShow: true, //客户备注内容是否显示
      inputShow: false, //备注内容输入框
      btnShow: true, //备注内容编辑按钮
      editShow: false, //备注内容保存按钮
      remarkDialogFormVisible: false, //备注信息弹窗
      dialogRemarkForm: {
        //备注信息表单内容
        remark: '',
      },
      mobileLength: '', //手机号码位数
      isCustInfo:true,
      // 车辆信息数据
      carInfoTable: [],
      carPagination: pageConfig.carPagination
    }
  },
  methods: {
    init() {
      if(this.$store.state.custObj){
        this.custInfo = this.$store.state.custObj;
        this.getFormInfo()
      }
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this
      _.detailForm.masterList = []
      _.detailForm.relList = []
      _.$H.post(_, _.$A.cust.listCustRelation, { mobile: _.custInfo.mobile,custType: _.custInfo.custType}).then((res) => {
        res.data.data.forEach(item => {
          if(item.custType =='桩主'){
            _.detailForm.masterList.push(item)
          }else{
            _.detailForm.relList.push(item)
          }
        })
      })
    },
    // 获取表单信息
    openHistorydig(flag) {
      let _ = this
      _.$H.post(_, _.$A.cust.listHirtoryCustRelation, { mobile: _.custInfo.mobile,custType:flag?'亲友':'桩主'}).then((res) => {
        _.detailForm.relHistoryList = res.data.data
        _.historyDialogVisible = true
        // _.$store.commit("setCurPhone", _.detailForm.mobile);
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
